<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="cpt-analytics">
      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="cpt-analytics">
      <!-- Dashboard heading -->
      <v-layout row wrap align-center>
        <v-flex xs12 sm4>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm4>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
        <v-flex xs12 sm4>
          <v-btn class="ma-0" @click="showFilters = true" ef-feature-id="filters-btn">
            <v-icon class="mr-1">filter_list</v-icon> {{ translation('filters.btn-filter') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <!-- Dashboard Filters -->
      <v-layout row v-show="showFilters">
        <cpt-logins-filter
          :dashboard-id="id"
          @close-filters="showFilters = false"
          @apply-filters="fetchDashboardData(); showFilters = false"
          @clear-filters="fetchDashboardData">
        </cpt-logins-filter>
      </v-layout>

      <!-- KPI Widgets -->
      <v-layout row wrap justify-center>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiTotalCptUsers">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiTotalLogins">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiUniqueLogins">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiAvgLoginsPerDay">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiTotalRegistrationsFinishedNotVerified">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiTotalRegistrationsFinished">
          </widget-kpi>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <widget-kpi
            widget-key="CustomerPortal_kpiTotalPwdResets">
          </widget-kpi>
        </v-flex>
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex xs12 lg6 v-if="hideCharts.indexOf('CustomerPortal_activeUserAccounts') === -1">
          <chart-line
            chart-key="CustomerPortal_activeUserAccounts"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
        <v-flex xs12 lg6 v-if="hideCharts.indexOf('CustomerPortal_totalSessions') === -1">
          <chart-line
            chart-key="CustomerPortal_totalSessions"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
        <v-flex xs12 lg6 v-if="hideCharts.indexOf('CustomerPortal_avgActiveUsersPerDay') === -1">
          <chart-line
            chart-key="CustomerPortal_avgActiveUsersPerDay"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
        <v-flex xs12 lg6 v-if="hideCharts.indexOf('CustomerPortal_totalSentInvites') === -1">
          <chart-line
            chart-key="CustomerPortal_totalSentInvites"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
        <v-flex xs12 lg6 v-if="hideCharts.indexOf('CustomerPortal_totalCompletedRegistrations') === -1">
          <chart-line
            chart-key="CustomerPortal_totalCompletedRegistrations"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
      </v-layout>

      <!-- Dashboard Charts -->
      <v-layout row wrap>
        <v-flex xs12>
          <chart-bar
            chart-key="CustomerPortal_loginsByMonth"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12>
          <chart-bar
            chart-key="CustomerPortal_unqLoginsByMonth"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12>
          <chart-bar
            chart-key="CustomerPortal_registrationsByMonth"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12>
          <chart-bar
            chart-key="CustomerPortal_registrationsBySource"
            @open-dialog="openDialog($event)">
          </chart-bar>
        </v-flex>
        <v-flex xs12>
          <chart-table
            chart-key="CustomerPortal_LoginTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
        <v-flex xs12>
          <chart-table
            chart-key="CustomerPortal_RegistrationTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
        <v-flex xs12>
          <chart-table
            chart-key="CustomerPortal_TotalRegistrationTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
        <v-flex xs12>
          <chart-table
            chart-key="CustomerPortal_DeletedUsersTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
        <v-flex xs12>
          <chart-table
            chart-key="CustomerPortal_MailTable"
            @open-dialog="openDialog($event)">
          </chart-table>
        </v-flex>
      </v-layout>

      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
// import CptLoginsFilter from '@/components/dashboards/cpt/DashboardCptLoginsFilterGen'
import CptLoginsFilter from '@/components/dashboards/cpt/DashboardCptLoginsFilterGenSidebar'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartBar from '@/components/charts/ChartBar'
import ChartBarRender from '@/components/charts/ChartBarRender'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineRender from '@/components/charts/ChartLineRender'
import ChartPie from '@/components/charts/ChartPie'
import ChartPieRender from '@/components/charts/ChartPieRender'
import ChartTable from '@/components/charts/ChartTable'
import ChartTableRender from '@/components/charts/ChartTableRender'
import PdfExport from '@/components/pdfExport'

export default {
  name: 'DashboardCptLogins',
  components: {
    BaseLoader,
    LastUpdateTime,
    CptLoginsFilter,
    WidgetKpi,
    ChartBar,
    ChartBarRender,
    ChartLine,
    ChartLineRender,
    ChartPie,
    ChartPieRender,
    ChartTable,
    ChartTableRender,
    PdfExport
  },
  data () {
    return {
      id: 'CustomerPortal',
      name: 'CPT Logins',
      charts: [
        {
          key: 'CustomerPortal_kpiTotalCptUsers',
          title: 'chart.title.CustomerPortal_kpiTotalCptUsers',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiTotalLogins',
          title: 'chart.title.CustomerPortal_kpiTotalLogins',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiUniqueLogins',
          title: 'chart.title.CustomerPortal_kpiUniqueLogins',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiAvgLoginsPerDay',
          title: 'chart.title.CustomerPortal_kpiAvgLoginsPerDay',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiTotalRegistrationsFinishedNotVerified',
          title: 'chart.title.CustomerPortal_kpiTotalRegistrationsFinishedNotVerified',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiTotalRegistrationsFinished',
          title: 'chart.title.CustomerPortal_kpiTotalRegistrationsFinished',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_kpiTotalPwdResets',
          title: 'chart.title.CustomerPortal_kpiTotalPwdResets',
          loaded: false,
          data: {},
          pagination: {}
        },
        {
          key: 'CustomerPortal_loginsByMonth',
          title: 'chart.title.CustomerPortal_loginsByMonth',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: 'name'
          }
        },
        {
          key: 'CustomerPortal_unqLoginsByMonth',
          title: 'chart.title.CustomerPortal_unqLoginsByMonth',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: 'name'
          }
        },
        {
          key: 'CustomerPortal_registrationsByMonth',
          title: 'chart.title.CustomerPortal_registrationsByMonth',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: 'name'
          }
        },
        {
          key: 'CustomerPortal_registrationsBySource',
          title: 'chart.title.CustomerPortal_registrationsBySource',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: true,
            sortBy: 'value'
          }
        },
        {
          key: 'CustomerPortal_LoginTable',
          title: 'chart.title.CustomerPortal_LoginTable',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          exportDetailed: false,
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'CustomerPortal_RegistrationTable',
          title: 'chart.title.CustomerPortal_RegistrationTable',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          exportDetailed: false,
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'CustomerPortal_TotalRegistrationTable',
          title: 'chart.title.CustomerPortal_TotalRegistrationTable',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          exportDetailed: false,
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'CustomerPortal_DeletedUsersTable',
          title: 'chart.title.CustomerPortal_DeletedUsersTable',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          exportDetailed: false,
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'CustomerPortal_MailTable',
          title: 'chart.title.CustomerPortal_MailTable',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          exportDetailed: false,
          chartSettings: {},
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 10
          }
        },
        {
          key: 'CustomerPortal_activeUserAccounts',
          title: 'chart.title.CustomerPortal_activeUserAccounts',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: false,
            keyModified: true,
            fillOpacity: 0.25,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'CustomerPortal_totalSessions',
          title: 'chart.title.CustomerPortal_totalSessions',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: false,
            keyModified: true,
            fillOpacity: 0.25,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'CustomerPortal_avgActiveUsersPerDay',
          title: 'chart.title.CustomerPortal_avgActiveUsersPerDay',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: false,
            keyModified: true,
            fillOpacity: 0.25,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'CustomerPortal_totalSentInvites',
          title: 'chart.title.CustomerPortal_totalSentInvites',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: false,
            keyModified: true,
            fillOpacity: 0.25,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        },
        {
          key: 'CustomerPortal_totalCompletedRegistrations',
          title: 'chart.title.CustomerPortal_totalCompletedRegistrations',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            legend: false,
            keyModified: true,
            fillOpacity: 0.25,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false,
            sortBy: null
          }
        }
      ],
      pdfExport: false,
      hideCharts: [],
      showFilters: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFilters', 'getCharts', 'getChartByKey', 'translation'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  destroyed () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
    .loader-wrapper {
        position: relative;
        height: 50px;
    }
</style>
